import React from "react";
import "./index.css";

function AlertModal({
  open,
  title,
  contents,
  onClick,
}: {
  open: boolean;
  title: string;
  contents: string;
  onClick(event: any): void;
}) {
  return open ? (
    <div className="modal">
      <div className="modal-wrapper">
        <div className="modal-contents">
          <div className="title text-xlarge font-bold pb-2">{title}</div>
          <div className="contents text-medium py-2">
            <p>{contents}</p>
          </div>
          <div className="buttons flex flex-end pt-1">
            <button
              className="modal-btn rounded px-4 py-2 font-medium"
              type="button"
              onClick={onClick}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default AlertModal;
